import { useEffect } from "react";


const usePageTitle = (title, description = null) => {
  useEffect(() => {
    document.title = title;

    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      } else {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        metaDescription.content = description;
        document.getElementsByTagName("head")[0].appendChild(metaDescription);
      }
    }
  }, [title, description]);
};

export default usePageTitle;

